import { createStore, combineReducers } from 'redux';
import movieReducer from './movieReducer';
import tvReducer from './tvReducer';

const rootReducer = combineReducers({
    movie: movieReducer,
    tv: tvReducer,
    // Add more reducers if needed
});

const store = createStore(rootReducer);

export default store;
